import type { StageId } from '@/types/stage-theme';

export type AppThemeMode = 'STATIC' | 'DYNAMIC';

function optionalEnv(key: keyof ImportMetaEnv): string {
  return import.meta.env[key]?.trim() ?? '';
}

function toStageNumber(value: string | undefined): StageId {
  return Number(value) as StageId;
}

function toThemeMode(value: string | undefined): AppThemeMode {
  return value?.trim().toUpperCase() === 'DYNAMIC' ? 'DYNAMIC' : 'STATIC';
}

export const appConfig = {
  api: {
    /** Forced empty to ensure game always runs fully offline and does not make API calls. */
    baseUrl: '',
    mockUserSessionUrl: '',
    adminBaseUrl: '',
  },
  stage: {
    id: optionalEnv('VITE_STAGE_ID'),
    number: toStageNumber(((typeof window !== "undefined" ? new URLSearchParams(window.location.search).get("stageNumber") : null) ?? import.meta.env.VITE_STAGE_NUMBER)),
    contentGameType: optionalEnv('VITE_STAGE_CONTENT_GAME_TYPE') || 'MAZE_NAVIGATION',
    themeMode: toThemeMode(import.meta.env.VITE_THEME_MODE),
  },
  encryption: {
    enabled: import.meta.env.VITE_ENCRYPTION_ENABLED === 'true',
    key: optionalEnv('VITE_ENCRYPTION_KEY'),
  },
} as const;

export type AppConfig = typeof appConfig;
